import {
  ACTION_ARGS,
  Arg,
  MODAL_ARGS,
  Metadata,
  pick,
  pickAll,
} from '../../../../utils/spds/metadata';
import {
  MODAL_DOCS_CTA_BLOCKS,
  assembleModalDescription,
} from '../../../../utils/spds/metadata/modal-docs';
import { hash } from '@ember/helper';
import Description from './media/description.gjs';
import FlexColumn from '../../layout/flex/column.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import MediaContainer from './media/container.gjs';
import ModalCta from '../shared/footer-cta.gjs';
import StandardModal from '../standard.gjs';
import Super from '../../core/base.gjs';
import Title from '../standard/header/title.gjs';
import styles from './media.module.scss';

const METADATA = Metadata.define({
  description: assembleModalDescription(
    'Used contextually to promote information. Includes media block for illustrations or video.',
    MODAL_DOCS_CTA_BLOCKS
  ),
  extends: [
    pick(ACTION_ARGS, [{ name: 'onClose', required: true }, 'onBeforeClose', 'onOpen']),
    pickAll(MODAL_ARGS, {
      overrides: {
        primaryBtnText: { initialValue: 'OK' },
        title: { initialValue: 'Announcement' },
      },
    }),
  ],
  meta: {
    description: Arg.string({
      description: 'Description text below the title',
      initialValue: '',
    }),
  },
  name: 'Media',
});

export default class SpdsModalAnnouncementMedia extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-announcement-media';

  <template>
    <StandardModal
      @closeOnClickOutside={{@closeOnClickOutside}}
      @id={{this.id}}
      @onBeforeClose={{@onBeforeClose}}
      @onClose={{@onClose}}
      @onOpen={{@onOpen}}
      @variantName={{this.componentName}}
      class={{styles.component}}
      data-test-spds-modal-announcement-media
      {{this.validateArguments}}
      ...attributes
      as |M|
    >
      <M.Body
        class="spds-modal-announcement-media-body"
        data-test-spds-modal-announcement-media-body
      >
        <MediaContainer @close={{M.beforeClose}}>
          {{yield to="media"}}
        </MediaContainer>
        <FlexColumn
          @alignItems="center"
          @alignSelf="stretch"
          @gap="16px"
          @justifyContent="center"
          class="spds-modal-announcement-media-text-container"
          data-test-spds-modal-announcement-media-text-container
        >
          {{#if @title}}
            <Title
              @title={{@title}}
              class="spds-modal-announcement-media-title"
              data-test-spds-modal-announcement-media-title
            />
          {{else}}
            <FlexRow
              class="spds-modal-announcement-media-title"
              data-test-spds-modal-announcement-media-title
            >
              {{yield to="title"}}
            </FlexRow>
          {{/if}}
          {{#if @description}}
            <Description @description={{@description}} />
          {{else}}
            <FlexRow
              class="spds-modal-announcement-media-description"
              data-test-spds-modal-announcement-media-description
            >
              {{yield to="description"}}
            </FlexRow>
          {{/if}}
        </FlexColumn>
      </M.Body>
      {{yield (hash beforeClose=M.beforeClose close=M.close)}}
      <M.Footer @justifyContent="center" data-test-spds-modal-announcement-media-footer>
        {{#if (has-block "cta")}}
          {{yield to="cta"}}
        {{else}}
          <ModalCta
            @beforeClose={{M.beforeClose}}
            @close={{M.close}}
            @primaryBtnAction={{@primaryBtnAction}}
            @primaryBtnText={{@primaryBtnText}}
            @primaryBtnDisabled={{@primaryBtnDisabled}}
            @secondaryBtnAction={{@secondaryBtnAction}}
            @secondaryBtnText={{@secondaryBtnText}}
            @secondaryBtnDisabled={{@secondaryBtnDisabled}}
          />
        {{/if}}
      </M.Footer>
    </StandardModal>
  </template>
}

export const MODAL_ANNOUNCEMENT_MEDIA_METADATA = SpdsModalAnnouncementMedia.metadata;
